<template>
  <div class="select">

    <select v-model="value"
            class="select__input"
    >

      <option :value="undefined"
              class="select__option"
              v-if="placeholder"
      >
        {{ placeholder }}
      </option>

      <option v-for="(option, key) in options"
              :disabled="!option.enabled"
              :value="option.id"
              :key="key"
              class="select__option"
      >
        {{ option.title }}
      </option>

    </select>

  </div>
</template>

<script>
export default {
  name: 'Select',

  props: {
    modelValue: {
      type: [
        String,
        Number,
      ],
    },
    options: {
      type: Object,
      required: true,
    },
    placeholder: {
      type: String,
    },
  },

  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/assets/css/select.scss';
</style>
